<script>
// 此处定义全局变量

const ERRCODE = {
  Success: 0,
  Busy: -1,
  TokenMissing: 10000,
  TokenError: 10001,
  PersonalInfoIncomplete: 10008,
  SecturityIncomplete: 10009,
  FullNameNotChecked: 10021,
  AccountLocked: 11002,
  AccountStop: 11003,
  UserNotFound: 11005,
  AccountException: 11009,
  UserEmptyMobile: 11011,
  MeDataNotValid: 13002,
  MeDataRecStateError: 13004,
  MeDataWaitTrial: 13005,
  ResumeNotFound: 14001,
  CompanyNotVerify: 21005,
  CompanyVerifyFail: 21006,
  NotFoundLicence: 21007,
  HrInfoIncomplete: 22002,
  HrNotAudit: 22005,
  GwInfoIncomplete: 31001,
  GwNotVerify: 31002,
  GwVerifyFail: 31003,  
};

const ME_SIGNCODE='DD72D96C';
const HR_SIGNCODE='A6DC05C7';

Object.freeze(ERRCODE);
export default {
  ERRCODE,
  ME_SIGNCODE,
  HR_SIGNCODE
};
</script>